import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)  // enables loading translation over http server
  .use(initReactI18next) // passes i18n instance to react-i18next
  .init({
    supportedLngs: ['en', 'fr'],
    fallbackLng: 'en',
    detection: {
      order: ['querystring', 'cookie'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',  // Path to your locales files
    },
    react: { useSuspense: false },  // Optional: this disables suspense feature
    debug: false,  // Log information in console
  });

export default i18n;
